import DOMPurify from 'dompurify';

const config = {
  ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'ul', 'ol', 'li', 'p', 'br'],
  ALLOWED_ATTR: [],
};

export const sanitizeHTML = (htmlString: string) => {
  return DOMPurify.sanitize(htmlString, config);
};

const SanitizedHTML = ({
  htmlString,
  classNames,
}: {
  htmlString: string;
  classNames?: string;
}) => {
  const sanitizedHtml = sanitizeHTML(htmlString);
  return (
    <div
      className={`displayed-html ${classNames}`}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};

export default SanitizedHTML;
